var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWorkSelectedwithbg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 7310",
    fill: "#006e94",
    stroke: "#006e94"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 7315",
    transform: "translate(8 12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 10.5,
    rx: 1.25
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 7316"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 8h6a1 1 0 011 1v4h-8V9a1 1 0 011-1z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8.75h6a.25.25 0 01.25.25v2.5a.75.75 0 01-.75.75h-5a.75.75 0 01-.75-.75V9a.25.25 0 01.25-.25z"
  })))));
}
export default SvgIcWorkSelectedwithbg;